export default __webpack_public_path__ + "static/timeup-1f439c3898124b127fe5a3e77b2ffae7.mp3";